export type ColorValue = string;

export const COLORS: Record<string, ColorValue> = {
  // Play type colors
  INSIGHT: 'var(--insight-color)',
  INSPECT: 'var(--inspect-color)',
  FOCUS: 'var(--focus-color)',
  RFID: 'var(--rfid-color)',
  SECURITY_CHECKPOINT: 'var(--security-walk-color)',
  SECURITY_PATROL: 'var(--security-color)',

  // Event type colors
  COMMAND: 'var(--command-color)',
  LIFECYCLE: 'var(--lifecycle-color)',
  NAV_ZONE: 'var(--nav-zone-color)',

  // Default color
  DEFAULT: '#FFFFFF'
} as const;
